import { useState } from 'react';
import { sandhillsRequest } from '@Components/Utilities/SandhillsUtility';
import TranslationText from '@Components/Utilities/TranslationText';
import WantToBuyListing from '@Components/WantToBuy/WantToBuyListing';
import atoms from '@Components/Utilities/SandhillsAtoms';
import { useRecoilValue } from 'recoil';

const WantToBuyListView = (props) => {

    const routes = useRecoilValue(atoms.routes);

    const [wantToBuys, setWantToBuys] = useState(props.WantToBuys ? props.WantToBuys.reduce((list, wtb) => {
        list[wtb.TranslatedEquipmentType] = list[wtb.TranslatedEquipmentType] || [];
        list[wtb.TranslatedEquipmentType].push(wtb);
        return list;
    }, {}) : null);

    const deleteWantToBuy = (id, equipmentType) => {
        sandhillsRequest({
            url: routes.WantToBuyDelete.replace("{0}", id),
            method: 'post',
            data: {
                WantToBuys: wantToBuys
            },
            errorHandling: {
                useConsole: false,
                useAlert: false
            }
        }).then(() => {
            setWantToBuys((previousState) => {
                let wantToBuys = {...previousState};
                wantToBuys[equipmentType] = wantToBuys[equipmentType].filter(wtb => wtb.WantToBuyMessageID != id);
                return wantToBuys;
            });
        });
    };

    return (
        <div>
            <div className='wtb-header'>
                <h3 className='mobile-hide'><TranslationText tKey='sandhills.mywanttobuys' /></h3>
                <a href={routes.WantToBuyView} className='account-button title'><TranslationText tKey='Sandhills.TradePubWebSite.PostAWantToBuy' /></a>
            </div>
            <div className='my-wtb'>
                {props.EquipmentTypeOptions.map((type, i) =>
                    <div key={i}>
                        <div className='wtb-sect-header'>
                            <div className='wtb-half'>
                                <h4>{type}</h4>
                            </div>
                            <div className='wtb-half'>
                                <h4>{(wantToBuys && wantToBuys[type] ? wantToBuys[type].length : '0')}</h4>
                            </div>
                        </div>
                        {wantToBuys && wantToBuys[type] && wantToBuys[type].length > 0 ?
                            <div key={type}>
                                {wantToBuys[type].map(wtb =>
                                    <WantToBuyListing {...wtb} key={wtb.WantToBuyMessageID} onDelete={() => deleteWantToBuy(wtb.WantToBuyMessageID, type)} />)}
                            </div>
                            :
                            <div>
                                <div className='wtb-entry'>
                                    <span className='no-wtb'><TranslationText tKey='Sandhills.NoWTBsFoundForThisCategory' /></span>
                                </div>
                            </div>}
                    </div>)}
            </div>
        </div>
    );
};

export default WantToBuyListView;
global.WantToBuyListView = WantToBuyListView;